<template lang="pug">
.coaches-top(ref='coachTopWrapper')
  template(v-if='isInAppWeb || isSignedInAndAppDisplayType')
    form.info(action='.', @submit.prevent='handleChangeInput')
      input#search-input(
        v-model.trim='searchInput',
        type='search',
        name='search',
        @change='handleChangeInput'
      )

      .filter-and-flow
        narrow-genre-button.btn-filter(
          :title='genreResult',
          @click='$emit("clickFilter")'
        )
        sort-review-button.btn-sort(title='並びかえ', @click='$emit("clickSort")')

  template(v-else)
    retina-image(:name='name', style='width: 100%')
    .title(:style='{ "margin-bottom": marginBottom }')
      p レッスンを受けたい先生を選んで、
        br/
        | 申し込みをしよう！
      p ※申し込みは先着順の為、レッスン枠が埋まっている場合があります。
</template>

<style lang="scss">
.coaches-top {
  width: 100%;
  position: relative;
  z-index: 2;

  .info {
    margin-bottom: 10px;
    padding: 0 16px;

    p {
      text-align: center;
      margin: 24px 0 16px 0;
    }

    .skip-sign-up {
      text-align: center;
      margin: 24px 0;
    }

    .filter-and-flow {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 0;
      padding: 0;

      .button {
        height: 40px;
        display: flex;
        align-items: center;
        background: transparent;

        .button-box {
          @extend %narrow-button;
          @extend %narrow-button-text;
          border: none;
          color: $text-title-color;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: auto;
          font-size: 14px;

          .svg-icon {
            display: inline-flex;
          }
        }
      }

      .btn-filter {
        margin: 0 !important;
        padding: 0;
      }

      .btn-sort {
        position: relative;
        padding: 0 0 0 16px;

        .button-box {
          box-shadow: none;
        }

        &::before {
          content: '';
          height: 24px;
          width: 1px;
          position: absolute;
          left: 0;
          top: 7px;
          background-color: rgba(255, 255, 255, 0.12);
        }
      }

      .icon-lesson-flow {
        position: absolute;
        right: 10px;
      }
    }

    @media (min-width: 768px) {
      .filter-and-flow {
        justify-content: space-around;
      }
    }

    .largeButton {
      margin: 0 8px !important;
      @media (max-width: 375px) {
        font-size: 15px !important;
      }
      @media (max-width: 320px) {
        font-size: 13px !important;
      }
    }

    &.is-flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .title {
    position: absolute;
    bottom: 0;
    margin-bottom: 42px;
    padding: 0 16px;

    p {
      margin: 0;
    }

    :first-child {
      @extend %headline-detail-text;
      margin-bottom: 8px;
    }
  }

  #search-input {
    position: relative;
    width: 100%;
    height: 40px;
    border-radius: 6px;
    border: none;
    color: white;
    text-align: center;
    font-size: 16px;
    padding: 0;
    background-color: rgba(255, 255, 255, 0.06);
    background-image: url('~@/assets/search-placeholder.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 118px 24px;

    &.input-focused {
      background-image: none;
    }

    &.input-with-value {
      background-image: none;
    }
  }

  input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    display: block;
    position: absolute;
    top: 10px;
    right: 16px;
    background-image: url('~@/assets/icons/close.png');
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: center;
  }

  input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import LargeButton from '@/components/atoms/LargeButton'
import NarrowGenreButton from '@/components/atoms/NarrowGenreButton'
import SortReviewButton from '@/components/atoms/SortReviewButton'
import Icon from '@/components/atoms/Icon'

const displayTypes = {
  no_logo: { name: 'app_coaches_top', marginBottom: '24px' },
  coach_list_only: {},
  with_logo: { name: 'web_coaches_top', marginBottom: '42px' },
}

export default {
  props: {
    keyword: { type: String, default: '' },
    isFetching: { type: Boolean, default: false },
    hasNextPage: { type: Boolean, default: false },
    danceKindList: {
      type: String,
      default: '',
    },
  },
  components: {
    LargeButton,
    NarrowGenreButton,
    SortReviewButton,
    Icon,
  },
  watch: {
    danceKindList() {
      if (this.danceKindList) {
        this.genreResult = this.danceKindList
      } else {
        this.genreResult = 'ジャンルを選ぶ'
      }
    },
    keyword(val) {
      this.searchInput = val

      if (!val) {
        document
          .getElementById('search-input')
          .classList.remove('input-with-value')
      }
    },
  },
  data() {
    return {
      searchInput: this.keyword,
      genreResult: 'ジャンルを選ぶ',
    }
  },
  computed: {
    ...mapGetters('displayType', [
      'isInAppWeb',
      'isSignedInAndAppDisplayType',
      'displayType',
    ]),
    name() {
      return displayTypes[this.displayType].name
    },
    marginBottom() {
      return displayTypes[this.displayType].marginBottom
    },
  },
  mounted() {
    document
      .querySelector('#coaches .page-content')
      .addEventListener('scroll', this.handlePageScrollDown)
  },
  beforeDestroy() {
    const coachesDOM = document.querySelector('#coaches .page-content')
    if (coachesDOM) {
      coachesDOM.removeEventListener('scroll', this.handlePageScrollDown)
    }
  },
  methods: {
    handlePageScrollDown(e) {
      this.fetchMoreCoach(e)
    },

    fetchMoreCoach(e) {
      if (
        e.target.scrollHeight - e.target.clientHeight <=
        e.target.scrollTop + 300
      ) {
        if (!this.isFetching && this.hasNextPage) {
          this.$emit('movePage', 'next')
        }
      }
    },

    // handle change input event
    handleChangeInput() {
      this.$emit('setKeywordCondition', this.searchInput)
      document.getElementById('search-input').blur()
      this.genreResult = 'ジャンルを選ぶ'
    },
  },
}
</script>
